export var FormFieldsPosition;
(function (FormFieldsPosition) {
    FormFieldsPosition["Out"] = "out";
    FormFieldsPosition["Inside"] = "inside";
})(FormFieldsPosition || (FormFieldsPosition = {}));
export var FormSelectionKind;
(function (FormSelectionKind) {
    FormSelectionKind["Single"] = "single";
    FormSelectionKind["Multiple"] = "multiple";
})(FormSelectionKind || (FormSelectionKind = {}));
export var FormFieldKind;
(function (FormFieldKind) {
    FormFieldKind["ShortText"] = "shortText";
    FormFieldKind["Email"] = "email";
    FormFieldKind["Phone"] = "phone";
    FormFieldKind["Date"] = "date";
    FormFieldKind["LongText"] = "longText";
    FormFieldKind["DropDown"] = "dropdown";
    FormFieldKind["Selection"] = "selection";
})(FormFieldKind || (FormFieldKind = {}));
//# sourceMappingURL=form.types.js.map